import React from "react";
import { Icon, Modal, PlainButton } from "@culturehq/components";

import { useProfile } from "app/context";
import { ProfileLink } from "app/links";
import { Trans } from "app/utils";
import UserActivityClaimedLink from "app/links/UserActivityClaimedLink";

import UserName from "components/common/UserName";
import QuickOptions from "components/display/QuickOptions";
import PinUserActivityToggle from "components/feed/feed-item/PinUserActivityToggle";

import ChqModal from "components/common/ChqModal";
import FeedItemTitle from "./FeedItemTitle";

const UserListModal = ({ children, users }) => (
  <ChqModal className="user-list-mdl" trigger={children}>
    <Modal.Heading>
      <Trans>{users.length} New Users Joined</Trans>
    </Modal.Heading>
    <Modal.Body>
      {users.map(user => (
        <div key={user.id} className="row user-list-mdl--row">
          <div className="col-xs-8">
            <UserName user={user} />
          </div>
          <div className="col-xs-4">{user.location?.name}</div>
        </div>
      ))}
    </Modal.Body>
  </ChqModal>
);

const UsersList = ({ user, childUserActivities = [] }) => {
  const users = [user, ...childUserActivities.map(({ entity }) => entity)];

  switch (users.length) {
    case 1:
      return <ProfileLink user={users[0]} />;
    case 2:
      return (
        <>
          <ProfileLink user={users[0]} /> and{" "}
          <ProfileLink user={users[1]} />
        </>
      );
    case 3:
      return (
        <>
          <ProfileLink user={users[0]} />,{" "}
          <ProfileLink user={users[1]} /> and{" "}
          <ProfileLink user={users[2]} />
        </>
      );
    default:
      return (
        <>
          <ProfileLink user={users[0]} />,{" "}
          <ProfileLink user={users[1]} />,{" "}
          <UserListModal users={users}>
            {onTrigger => (
              <PlainButton onClick={onTrigger}>
                and {users.length - 2} others
              </PlainButton>
            )}
          </UserListModal>
        </>
      );
  }
};

const UserClaimed = ({ item, onUserActivityUpdate }) => {
  const { profile } = useProfile();

  return (
    <div className="FeedItem__preview__user_claimed">
      <FeedItemTitle item={item} date={item.bumpedAt}>
        <QuickOptions>
          <ul className="dropdown-menu">
            <li>
              <UserActivityClaimedLink feedItem={item}>
                <Icon icon="eye" />
                <Trans>View this new users entry</Trans>
              </UserActivityClaimedLink>
            </li>
            {profile.organizationAdmin && (
              <li>
                <PinUserActivityToggle
                  userActivity={item}
                  onUserActivityUpdate={onUserActivityUpdate}
                />
              </li>
            )}
          </ul>
        </QuickOptions>
        <h3 className="FeedItem__title">
          <UsersList
            user={item.entity}
            childUserActivities={item.childUserActivities}
          />{" "}
          <Trans>joined the CultureHQ Community</Trans> 🎉
        </h3>
      </FeedItemTitle>
    </div>
  );
};

export default UserClaimed;
